export const LayoutModus = `
div.modus-layout
      ├── nav.modus-header
      ├── div.modus-body
      |   ├── nav.modus-sidebar
      |   └── div.modus-content-rows
      |       ├── div.modus-toolbar(optional)
      |       └── div.modus-content-columns
      |           ├── div.modus-panel(optional)
      |           └── div.modus-content
      └── div.modus-footer`
